import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import '../Components/Styles/SearchBar.css';

function SearchBar() {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const ref = useRef();

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  useEffect(() => {
    if (query.length < 2) { setResults([]); setOpen(false); return; }
    const timer = setTimeout(() => {
      setLoading(true);
      fetch(`/api/search.php?q=${encodeURIComponent(query)}`)
        .then(res => res.json())
        .then(data => {
          setResults(data);
          setOpen(true);
          setLoading(false);
        });
    }, 300);
    return () => clearTimeout(timer);
  }, [query]);

  const handleSelect = (item) => {
    setQuery('');
    setOpen(false);
    if (item.type === 'produit')   navigate(`/produit/${item.id}`);
    if (item.type === 'categorie') navigate(`/categorie/${item.id}`);
    if (item.type === 'marque')    navigate(`/categorie/${item.id}`);
  };

  const typeLabel = { produit: 'Produit', categorie: 'Catégorie', marque: 'Marque' };
  const typeColor = { produit: '#1a1a1a', categorie: '#2a6dd9', marque: '#e07b00' };

  return (
    <div className="searchbar-wrapper" ref={ref}>
      <div className="searchbar-input-wrap">
        <svg className="searchbar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
        <input
          type="text"
          placeholder="Rechercher un produit, une marque..."
          value={query}
          onChange={e => setQuery(e.target.value)}
          className="searchbar-input"
        />
        {query && (
          <button className="searchbar-clear" onClick={() => { setQuery(''); setOpen(false); }}>✕</button>
        )}
      </div>

      {open && (
        <div className="searchbar-dropdown">
          {loading && <p className="searchbar-msg">Recherche...</p>}
          {!loading && results.length === 0 && (
            <p className="searchbar-msg">Aucun résultat pour "{query}"</p>
          )}
          {!loading && results.map((item, i) => (
            <div key={i} className="searchbar-result" onClick={() => handleSelect(item)}>
              {item.type === 'produit' && item.image && (
                <img src={`/static/media/${item.image}`} alt={item.nom} className="searchbar-thumb" />
              )}
              <span className="searchbar-name">{item.nom}</span>
              <span className="searchbar-tag" style={{ color: typeColor[item.type] }}>
                {typeLabel[item.type]}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default SearchBar;